import { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import 'react-quill/dist/quill.snow.css';
import "react-quill/dist/quill.snow.css";
import { useLoading } from '../../../context/LoadingContext';
import React from 'react'
 
function Batch_master({ adminData }) {

  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);


  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [items, setItems] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [batch, setBatch] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [formItems, setFormItems] = useState({
    batch_no: '',
    mfg: '',
    exp: '',
    item: '',

  })

  const handleAddClick = () => {
    setShowForm(true);
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };






  const handleUpdate = async (e) => {
    e.preventDefault();

    const sendData = {
      batch_no: formItems.batch_no,
      mfg: formItems.mfg,
      exp: formItems.exp,
      item: {
        id: selectedItem?.id,
        name: selectedItem?.name,
      },
    };

    try {
      let res;

      if (isEditMode && editingCompanyId) {
        res = await axios.put(
          `https://api.skyguard.group/api/update-batch-master/${editingCompanyId}`,
          sendData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        res = await axios.post(
          "https://api.skyguard.group/api/add-batch-master",
          sendData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      showToast(
        isEditMode
          ? "Batch Updated Successfully!"
          : "Batch Added Successfully!",
        "success"
      );
      fecthBatchDetail();
      resetForm();
      setShowForm(false)
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast(
        isEditMode ? "Failed to update!" : "Failed to create!",
        "danger"
      );
    }
  };


  const handleEdit = (form) => {

    let parsedItem = null;

    if (form.item) {
      parsedItem =
        typeof form.item === "string"
          ? JSON.parse(form.item)
          : form.item;
    }

    setFormItems({
      id: form.id || '',
      batch_no: form.batch_no || '',
      mfg: form.mfg || '',
      exp: form.exp || '',
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);

    setSelectedItem(
      parsedItem
        ? {
          id: parsedItem.id,
          name: parsedItem.name,
        }
        : null
    );

  };


  const resetForm = () => {
    setFormItems({
      batch_no: "",
      mfg: "",
      exp: "",
    });

    setSelectedItem(null);


    setIsEditMode(false);
    setEditingCompanyId(null);
  };


  const fecthInventoryDetail = async () => {
    setLoading(true)
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];
      setItems(items);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fecthBatchDetail = async () => {
        setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-batch');

      setBatch(res.data);
   
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fecthInventoryDetail();
    fecthBatchDetail();

  }, []);

  const filterBatch = batch.filter((tt) => {
    const term = searchTerm.toLowerCase();

    return (
      (tt.batch_no && tt.batch_no.toLowerCase().includes(term))

    );
  });


  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };


  return (

    <div className='main-section'>
      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <h3 className='my-3 fw-bold fs-5 golos'>BATCH MASTER</h3>
        <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
          <div class="col-12 col-md-4">
            <input
              type="text"
              class="form-control"
              id="searchInput"
              placeholder="Search by Batch ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleAddClick} >
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (
          <form onSubmit={handleUpdate}>


            <div className='card p-3 my-3 shadow-sm bg-white border'>
              <div className='row'>
                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formItems.batch_no}
    </span>
  </div>
)}
                <div className='col-12'>
                  <div className='row g-3'>



                    <div className="col-12 col-sm-12 col-md-4">
                      <label className="form-label fw-medium">Batch NO.</label>
                      <input
                        type="text"
                        className="form-control"
                        name="batch_no"
                        value={formItems.batch_no}
                        onChange={handleChange}
                      />

                    </div>


                    <div className="col-12 col-sm-12  col-md-4">
                      <label className="form-label fw-medium">Items:</label>


                      <Select
                        options={items.map((t) => ({
                          value: t.id,
                          label: t.name,
                          name: t.name,
                        }))}

                        value={
                          selectedItem
                            ? {
                              value: selectedItem.id,
                              label: selectedItem.name,
                            }
                            : null
                        }

                        onChange={(e) =>
                          setSelectedItem(
                            e
                              ? {
                                id: e.value,
                                name: e.name,
                              }
                              : null
                          )
                        }

                        className="w-100"
                        menuPlacement="auto"
                      />


                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">MFD </label>
                      <input
                        type="date"
                        className="form-control"
                        name="mfg"
                        value={formItems.mfg}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">EXP </label>
                      <input
                        type="date"
                        className="form-control"
                        name="exp"
                        value={formItems.exp}
                        onChange={handleChange}
                      />
                    </div>


                  </div>
                </div>




                <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                  <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                  <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                </div>
              </div>
            </div>


          </form>
        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                 <th scope='col' >Action</th>
                <th scope='col' >Batch No. </th>
                <th scope='col'>MFD</th>
                <th scope='col'>EXP</th>

                
              </tr>
            </thead>
            <tbody>
              {filterBatch.length > 0 ? (
                filterBatch.map((item, index) => (
                  <tr key={index}>
                       <td>  <button
                      className="btn btn-warning"

                      onClick={() => handleEdit(item)}
                    >
                      <CiEdit size={20} />
                    </button>
                    </td>
                    <td>{item.batch_no}</td>
                    <td>{formatDate(item.mfg)}</td>
                    <td>{formatDate(item.exp)}</td>
                 
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </div>

    </div>
  )
}

export default Batch_master